import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

const routes = [
    {
        path: '*',
        redirect: '/index'
    },
    {
        name: 'index',
        component: () => import('./view/index'),
        meta: {
            title: '初始化',
            auth: false,
            keepAlive: false
        }
    },
    {
        name: 'product',
        component: () => import('./view/product'),
        meta: {
            title: '产品中心',
            auth: false,
            keepAlive: false
        }
    },
    {
        name: 'productDetail',
        component: () => import('./view/product/detail'),
        meta: {
            title: '产品中心',
            auth: false,
            keepAlive: false
        }
    },
    {
        name: 'solution',
        component: () => import('./view/solution'),
        meta: {
            title: '解决方案',
            auth: false,
            keepAlive: false
        }
    },
    {
        name: 'case',
        component: () => import('./view/case'),
        meta: {
            title: '行业案例',
            auth: false,
            keepAlive: false
        }
    },
    {
        name: 'about',
        component: () => import('./view/about'),
        meta: {
            title: '关于我们',
            auth: false,
            keepAlive: false
        }
    },
    {
        name: 'contact',
        component: () => import('./view/contact'),
        meta: {
            title: '联系我们',
            auth: false,
            keepAlive: false
        }
    }
];
// add route path
routes.forEach(route => {
    route.path = route.path || '/' + (route.name || '');
});

const router = new Router({
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    }
});

router.beforeEach((to, from, next) => {
    next();
});

export {
    router
};
